module.exports = __webpack_public_path__ + "static/media/logo.53a9a489.svg";